import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/dailyWorker/selectPage',
    method: 'GET',
    params: {
      ...params
    }
  })
}

// 导出成本统计
export function download (params) {
  return axios({
    url: '/dailyWorker/download',
    method: 'get',
    params: params,
    responseType: 'arraybuffer'
  })
}
// 考勤上报差序日报上报得考勤信息
export function getDailyWorkerHours (params) {
  return axios({
    url: '/dailyWorker/getDailyWorkerHours',
    method: 'GET',
    params: {
      ...params
    }
  })
}
